var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { format, parse } from "date-fns";
var PPN_DATE_FORMAT = "yyyy-MM-dd";
var PCLN_UI_DATE_FORMAT = "yyyyMMdd";
export function formatPPNDate(date) {
    return format(date, PPN_DATE_FORMAT);
}
export function formatPPNPostalCode(countryCode, postalCode) {
    if (countryCode === void 0) { countryCode = "US"; }
    if (postalCode && countryCode.match(/CA/gi)) {
        postalCode = postalCode.replace(/\s+/g, "");
        if (postalCode.length === 6) {
            return postalCode.slice(0, 3) + " " + postalCode.slice(3);
        }
    }
    return postalCode;
}
export function parsePPNDate(dateString) {
    return parse(dateString, PPN_DATE_FORMAT, new Date());
}
export function formatPCLNUIDate(date) {
    return format(date, PCLN_UI_DATE_FORMAT);
}
export function parsePPNPlace(data) {
    var id = "";
    var type = "city";
    if ("city_id" in data) {
        id = data.city_id;
    }
    else if ("airport_id" in data) {
        id = data.airport_id;
        type = "airport";
    }
    else if ("airport_code" in data) {
        id = data.airport_code;
        type = "airport";
    }
    else if ("hotel" in data) {
        id = data.hotel_id;
        type = "hotel";
    }
    return {
        id: id,
        type: type,
    };
}
export function parsePPNQuerySearch(data) {
    var params = new URLSearchParams(data);
    var search = Object.fromEntries(params.entries());
    var location = parsePPNPlace(search);
    return {
        location: location,
        checkIn: search["check_in"],
        checkOut: search["check_out"],
        roomCount: search["rooms"] || 1,
        adultCount: search["adults"] || 2,
        children: search["children"],
    };
}
export function createPPNHotelAPIQueryString(
//request: Partial<HotelSearchRequest>,
request, _a) {
    var e_1, _b, e_2, _c;
    var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var _q = _a === void 0 ? {} : _a, singleHotel = _q.singleHotel;
    var query = "";
    var _r = __read(request.budget || [], 2), minBudget = _r[0], maxBudget = _r[1];
    switch ((_d = request.location) === null || _d === void 0 ? void 0 : _d.type) {
        case "airport":
            query += "airport_code=".concat(request.location.id);
            break;
        case "city":
            query += "city_id=".concat(request.location.id);
            break;
        case "poi":
        case "geo":
            query += "latitude=".concat((_e = request.location.coords) === null || _e === void 0 ? void 0 : _e.latitude, "&longitude=").concat((_f = request.location.coords) === null || _f === void 0 ? void 0 : _f.longitude);
            break;
        case "hotel":
            query += "hotel_id".concat(!singleHotel ? "s" : "", "=").concat(request.location.id);
            break;
    }
    if (request.checkIn) {
        query += "&check_in=".concat(formatPPNDate(request.checkIn));
    }
    if (request.checkOut) {
        query += "&check_out=".concat(formatPPNDate(request.checkOut));
    }
    if (request.partnerID) {
        query += "&refclickid=".concat(request.partnerID).concat(request.refClickID && request.refClickID !== request.partnerID
            ? ":".concat(request === null || request === void 0 ? void 0 : request.refClickID)
            : "");
    }
    if (request.currency) {
        query += "&currency=".concat(request.currency);
    }
    if ((_g = request.amenities) === null || _g === void 0 ? void 0 : _g.length) {
        query += "&amenity_data=[".concat(request.amenities.toString(), "]");
    }
    if ((_h = request.brands) === null || _h === void 0 ? void 0 : _h.length) {
        query += "&hotel_chain=[".concat(request.brands.toString(), "]");
    }
    if ((_j = request.guestRatings) === null || _j === void 0 ? void 0 : _j.length) {
        var max_1 = 10;
        var lowest = max_1;
        try {
            for (var _s = __values(request.guestRatings), _t = _s.next(); !_t.done; _t = _s.next()) {
                var rating = _t.value;
                rating = Number(rating);
                if (rating < lowest) {
                    lowest = rating;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_t && !_t.done && (_b = _s.return)) _b.call(_s);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var param = Array.from(new Array(max_1 - lowest + 1))
            .map(function (_, index) { return max_1 - index; })
            .toString();
        query += "&review_rating=[".concat(param, "]");
    }
    if ((_k = request.stars) === null || _k === void 0 ? void 0 : _k.length) {
        var max_2 = 10;
        var lowest = max_2;
        try {
            for (var _u = __values(request.stars), _v = _u.next(); !_v.done; _v = _u.next()) {
                var rating = _v.value;
                rating = Number(rating);
                if (rating < lowest) {
                    lowest = rating;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_v && !_v.done && (_c = _u.return)) _c.call(_u);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var param = Array.from(new Array(max_2 - lowest + 1))
            .map(function (_, index) { return max_2 - index; })
            .toString();
        query += "&star_rating=[".concat(param, "]");
    }
    if ((_l = request.neighborhoods) === null || _l === void 0 ? void 0 : _l.length) {
        query += "&neighborhood=[".concat(request.neighborhoods.toString(), "]");
    }
    if (minBudget && maxBudget) {
        query += "&min=".concat(minBudget, "&max=").concat(maxBudget);
    }
    if ((((_m = request.rateOptions) === null || _m === void 0 ? void 0 : _m.indexOf("free-cancellation")) || 0) > -1) {
        query += "&is_cancellable=true";
    }
    if ((((_o = request.rateOptions) === null || _o === void 0 ? void 0 : _o.indexOf("postpaid")) || 0) > -1) {
        query += "&postpaid=true";
    }
    if (request.sort) {
        var _w = __read(request.sort.split("|"), 2), sort = _w[0], order = _w[1];
        query += "&sortBy=".concat(sort);
        if (order) {
            query += "&order=".concat(order);
        }
    }
    else if (request.defaultSort === "discount") {
        query += "&sortBy=discount";
    }
    if (request.search) {
        query += "&q=".concat(request.search);
    }
    query += "&rooms=".concat(request.roomCount || 1, "&adults=").concat(request.adultCount || 2);
    if ((_p = request.children) === null || _p === void 0 ? void 0 : _p.length) {
        query += "&children=".concat(request.children.length);
    }
    if (request.campaign || request.cid) {
        query += "&cid=".concat(request.campaign || request.cid);
    }
    return query;
}
export function santizePPNPolicyText(text) {
    var sanitized = text.replace(/#[^#]*#/g, "");
    return sanitized;
}
